import { animated, useSpring } from '@react-spring/web';
import React from 'react';
import { usePodState } from '../../helpers/podHelper';
import { FlexboxColumn } from '../action/Flexbox';
import OTPInput from '../action/OTPInput';
import ThemedText from '../theme/ThemedText';

const Submit = () => {
  const [{ handleSubmitCode, backToHome }] = usePodState();

  const springProps = useSpring({
    from: { transform: 'translateX(80%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
    config: { tension: 200, friction: 30 },
  });

  return (
    <animated.div className='identity_wrapper__animation' style={springProps}>
      <FlexboxColumn className='submit_container' gap='1.25rem'>
        <ThemedText.H5 weight='medium'>Enter Peer Request Code</ThemedText.H5>
        <FlexboxColumn>
          <OTPInput length={5} />
        </FlexboxColumn>
        <button onClick={handleSubmitCode}>Submit Code</button>

        <ThemedText.P className='backToHome' onClick={backToHome}>
          GO BACK TO HOME
        </ThemedText.P>
      </FlexboxColumn>
    </animated.div>
  );
};

export default Submit;
